import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Layout
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";

// Pages
import Home from "@/pages/Home";
import About from "@/pages/About";
import OurPets from "@/pages/OurPets";
import Applications from "@/pages/Applications";
import Donate from "@/pages/Donate";
import DangerZone from "@/pages/DangerZone";
import Store from "@/pages/Store";
import Contact from "@/pages/Contact";
import FosterResources from "@/pages/FosterResources";
import AdminCosts from "@/pages/AdminCosts";
import AdminBalance from "@/pages/AdminBalance";
import Contest from "@/pages/Contest";
import AdminContest from "@/pages/AdminContest";
import CarliBirthday from "@/pages/CarliBirthday";
import ExternalRedirect from "@/pages/ExternalRedirect";
import AmazonWishlist from "@/pages/AmazonWishlist";
import Resources from "@/pages/Resources";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="our-pets" element={<OurPets />} />
            <Route path="applications" element={<Applications />} />
            <Route path="donate" element={<Donate />} />
            <Route path="danger-zone" element={<DangerZone />} />
            <Route path="amazon-wishlist" element={<AmazonWishlist />} />
            <Route path="resources" element={<Resources />} />
            <Route path="store" element={<Store />} />
            <Route path="contact" element={<Contact />} />
            <Route path="foster-resources" element={<FosterResources />} />
            <Route path="contest" element={<Contest />} />
          </Route>
          {/* Hidden admin routes - not in navigation */}
          <Route path="/admin/costs" element={<AdminCosts />} />
          <Route path="/admin/balance" element={<AdminBalance />} />
          <Route path="/admin/contest" element={<AdminContest />} />
          
          {/* Hidden fundraiser pages */}
          <Route path="/carli" element={<CarliBirthday />} />
          
          {/* External redirects - multiple cases for case-insensitivity */}
          <Route path="/boop" element={<ExternalRedirect url="https://www.zeffy.com/en-US/ticketing/halloween-shirt-sale" />} />
          <Route path="/BOOP" element={<ExternalRedirect url="https://www.zeffy.com/en-US/ticketing/halloween-shirt-sale" />} />
          <Route path="/Boop" element={<ExternalRedirect url="https://www.zeffy.com/en-US/ticketing/halloween-shirt-sale" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
